import { render, staticRenderFns } from "./ModalTextInput.vue?vue&type=template&id=0de587b2&"
import script from "./ModalTextInput.vue?vue&type=script&lang=js&"
export * from "./ModalTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports